<script>
import options from './FormInputDropdown.options'
export default options
</script>

<template>
  <article class="kb-form-input-dropdown" :class="{ ValidationRequired: isRequired }">
    <label :for="`dropdown-${fieldName}`" class="Form__Element__Caption"
      >{{ label }}
      <template v-if="tooltipText">
        <TooltipComponent :tooltipText="tooltipText" />
      </template>
    </label>
    <div class="Form__Element kb-form-input-dropdown__wrapper">
      <select :id="`dropdown-${fieldName}`" v-model="localValue" @change="formLink" :required="isRequired ? true : false">
        <option value="" disabled>{{ placeholder }}</option>
        <template v-for="(option, index) in selectOptions" :key="index">
          <option :value="option.value">
            {{ option.name }}
          </option>
        </template>
      </select>
      <div class="kb-form-input-dropdown__wrapper--arrow">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.5 10.5 12 14.25 7.5 10.5"
            stroke="#3C3C3C"
            stroke-width="1.5"
            stroke-linejoin="round"
          />
        </svg>
      </div>
    </div>
    <p
      class="Form__Element__ValidationError"
      v-if="inputHasValidationErrors && isValidationError"
      aria-live="assertive"
    >
      {{ errorMessageLabel }}
    </p>
    <p
      class="kb-form__input-helptext kb-form__input-helptext--dropdown"
      v-if="helpMessageLabel"
    >
      {{ helpMessageLabel }}
    </p>
  </article>
</template>
